import { apiService } from './api'
import { Usuario } from '../types'

interface LoginResponse {
  access_token: string
  token_type: string
  expires_in: number
}

class AuthService {
  async login(username: string, password: string): Promise<LoginResponse> {
    return apiService.post<LoginResponse>('/auth/login', { username, password })
  }

  async logout(): Promise<void> {
    await apiService.post('/auth/logout')
  }

  async getCurrentUser(token?: string): Promise<Usuario> {
    return apiService.get<Usuario>(
      '/auth/me',
      token ? { headers: { Authorization: `Bearer ${token}` } } : undefined
    )
  }

  async refreshToken(): Promise<LoginResponse> {
    return apiService.post<LoginResponse>('/auth/refresh')
  }

  async changePassword(currentPassword: string, newPassword: string): Promise<void> {
    await apiService.post('/auth/change-password', {
      current_password: currentPassword,
      new_password: newPassword,
    })
  }

  async updateCurrentUser(data: {
    username?: string
    email?: string
    password?: string
    nombre?: string
    apellidos?: string
    foto_perfil?: string
    pagina_inicio?: string
    configuracion?: Record<string, unknown>
  }): Promise<Usuario> {
    return apiService.put<Usuario>('/auth/me', data)
  }

  async updateUserPassword(userId: number, newPassword: string): Promise<void> {
    await apiService.put(`/auth/users/${userId}/password`, { password: newPassword })
  }
}

export const authService = new AuthService()
